import { BEER_PRICE, CUP_REFUND } from '../config';
import orderBalancesCore from './orderBalancesCore';
const { calcSummary: calculate } = orderBalancesCore;

// Show only amounts this person receives; debts remain in the person rows.
export function getSummaryCardTotal(against = {}) {
  return Math.round(Object.values(against).reduce((sum, amount) => sum + Math.max(0, Number(amount) || 0), 0) * 100) / 100;
}

export function calcSummary(transactions, cfg = {}) {
  return calculate(transactions, { ...cfg, BEER_PRICE: cfg?.BEER_PRICE ?? BEER_PRICE, CUP_REFUND: cfg?.CUP_REFUND ?? CUP_REFUND });
}
export default calcSummary;
